const InvestmentHyfye = () => { 
    return (
      <section>
        <div className="container">
          <div className="row align-items-center">
            
            {/* Left Side - Text Content */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="title_dark title_border">
                <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                  Fuel the Future of a Borderless Economy
                </h4>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                  Hyfye is building a decentralized world where gratitude is real currency. Every interaction — a like, a post, a tip — becomes a way to earn and empower others.
                  <br/><br/>
                  Invest in Hyfye today and be part of the first global, community-powered tipping network where every action counts, every voice matters, and every opportunity is borderless.
                </p>
              </div>
  
              {/* Features List */}
              <ul className="list_info list_info_half list_none">
                <li className="animation" data-animation="fadeInUp" data-animation-delay="0.5s">
                  <div className="list_icon"><i className="fa fa-users"></i></div>
                  <div className="list_content">
                    <h6>Community-Owned Growth</h6>
                  </div>
                </li>
                <li className="animation" data-animation="fadeInUp" data-animation-delay="0.6s">
                  <div className="list_icon"><i className="fa fa-briefcase"></i></div>
                  <div className="list_content">
                    <h6>Earn from Every Action</h6>
                  </div>
                </li>
                <li className="animation" data-animation="fadeInUp" data-animation-delay="0.7s">
                  <div className="list_icon"><i className="fa fa-mobile"></i></div>
                  <div className="list_content">
                    <h6>Access Anytime, Anywhere</h6>
                  </div>
                </li>
                <li className="animation" data-animation="fadeInUp" data-animation-delay="0.8s">
                  <div className="list_icon"><i className="fa fa-globe"></i></div>
                  <div className="list_content">
                    <h6>Borderless Digital Economy</h6>
                  </div>
                </li>
                <li className="animation" data-animation="fadeInUp" data-animation-delay="0.9s">
                  <div className="list_icon"><i className="fa fa-bolt"></i></div>
                  <div className="list_content">
                    <h6>Lightning-Fast Transactions</h6>
                  </div>
                </li>
                <li className="animation" data-animation="fadeInUp" data-animation-delay="1s">
                  <div className="list_icon"><i className="fa fa-leaf"></i></div>
                  <div className="list_content">
                    <h6>Eco-Friendly Blockchain Future</h6>
                  </div>
                </li>
              </ul>
            </div>
  
            {/* Right Side - Image */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-center res_md_mt_50 res_sm_mt_20">
                <img src="assets/images/investment_network.png" alt="Invest in Hyfye" />  
              </div>
            </div>
  
          </div>
        </div>
      </section>
    )
  }
  
  export default InvestmentHyfye;
  